export default "__VITE_ASSET__IRJNAxQj__"